module.exports = __webpack_public_path__ + "static/media/Cup_large.b02fb434.png";